const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  apps: [],
  tags: {
    "data": {
        "id": 0,
        "name": "",
        "parentId": null,
        "metaData": null,
        "createdAt": "",
        "updatedAt": "",
        "tags": [],
        "children": []
    },
    "status": true
      },
  categoryList: {
    "data": {
        "id": 0,
        "name": "",
        "parentId": null,
        "metaData": null,
        "createdAt": "",
        "updatedAt": "",
        "tags": [],
        "children": []
    },
    "status": true
},
}

const applicationSlice = createSlice({
  name: "applicationSlice",
  initialState,
  reducers: {
    myApplicationList: (state, action) => {
      state.apps = action.payload;
    },
    addTagCategories: (state, action) => {
      state.tags = action.payload;
    },
    addCategories: (state, action) => {
      state.categoryList = action.payload;
    }
  }
});

export const { myApplicationList, addTagCategories, addCategories } = applicationSlice.actions;
export default applicationSlice.reducer;